import { BreakPoints } from '@picsart/cascade';
import { hideScrollbars, ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    main: {
      backgroundColor: 'var(--backgrounds-tint-1)',
    },
    sidebar: {
      background: 'var(--backgrounds-tint-1)',
      '& > div': {
        width: 'calc(100% - 16px)',
        background: '#fff',
        boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 0.24)',
        ...hideScrollbars,
      },
      maxWidth: 272,
      [mediaQuery(breakpoints.laptop)]: {
        display: 'none',
      },
    },
    header: {
      display: 'none',
      padding: [14, 24],
      [mediaQuery(breakpoints.laptop)]: {
        display: 'flex',
      },
    },
    content: {
      height: '100%',
      display: 'flex',
      gap: 60,

      [mediaQuery(breakpoints.laptop)]: {
        marginInline: 'auto',
      },
      [mediaQuery(BreakPoints.Small)]: {
        display: 'block',
      },
    },
  }),
  { name: 'Layout' },
);
export default useStyles;
